/**
 * Admin-typed custom plan labels (SubscriptionManagementPage.tsx's "Plan Label"
 * free-text box) get stored verbatim as plan_name/plan_tier — e.g. an admin
 * typing "special_offer_free" saves exactly that, no title-casing. Every
 * member-facing display of a plan name/tier should run through this so a
 * raw slug-looking string never reaches a visitor unformatted.
 *
 * Idempotent on already-clean names ("Premium Custom" stays "Premium Custom"),
 * so it's safe to apply everywhere a plan name is shown, not just custom ones.
 */
export function formatPlanName(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
